import { Box, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

import MyAvatar from 'src/components/MyAvatar';
import useAuth from 'src/hooks/useAuth';
import { usePermissions } from 'src/hooks/usePermissions';
import { PATH_DASHBOARD } from 'src/routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

const NavbarAccountBody: React.FC<Props> = ({ isCollapse }) => {
  const { user } = useAuth();

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          bgcolor: 'transparent',
        }),
      }}
    >
      <MyAvatar />

      <Box
        sx={{
          ml: 2,
          transition: (theme) =>
            theme.transitions.create('width', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(isCollapse && {
            ml: 0,
            width: 0,
          }),
        }}
      >
        <Typography
          variant="subtitle2"
          noWrap
          sx={{
            color: 'text.secondary',
            width: isCollapse ? 'unset' : 130,
            display: 'block',
          }}
        >
          {user?.current_organization.business_type === 'business'
            ? user?.current_organization?.name ?? ''
            : user?.user.first_name ?? ''}
        </Typography>
        <Typography
          variant="caption"
          noWrap
          sx={{
            color: 'text.secondary',
            width: isCollapse ? 'unset' : 130,
            display: 'block',
          }}
        >
          {user?.user.email}
        </Typography>
      </Box>
    </RootStyle>
  );
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { is } = usePermissions();

  return is('owner') ? (
    <Link
      underline="none"
      color="inherit"
      component={RouterLink}
      to={PATH_DASHBOARD.user.account}
    >
      <NavbarAccountBody isCollapse={isCollapse} />
    </Link>
  ) : (
    <NavbarAccountBody isCollapse={isCollapse} />
  );
}
